// extracted by mini-css-extract-plugin
module.exports = {"container":"video-player_container__14bqE","invalidUrl":"video-player_invalidUrl__32CKn","frame":"video-player_frame__1Kug6"};